import { Navigate, Outlet } from "react-router-dom";
import { useAuthStore } from "../../stores/authStore";

export function ProtectedRoute() {
  const { isAuthenticated, hasHydrated } = useAuthStore((state) => ({
    isAuthenticated: state.isAuthenticated,
    hasHydrated: state.hasHydrated,
  }));

  if (import.meta.env.VITE_E2E === "true") {
    return <Outlet />;
  }

  if (!hasHydrated) {
    const cached = localStorage.getItem("auth-storage");
    if (cached) {
      try {
        const parsed = JSON.parse(cached) as {
          state?: { isAuthenticated?: boolean };
        };
        if (parsed.state?.isAuthenticated) {
          return <Outlet />;
        }
      } catch {
        // ignore parse errors
      }
    }
    return null;
  }

  if (!isAuthenticated) {
    const cached = localStorage.getItem("auth-storage");
    if (cached) {
      try {
        const parsed = JSON.parse(cached) as {
          state?: { isAuthenticated?: boolean };
        };
        if (parsed.state?.isAuthenticated) {
          return <Outlet />;
        }
      } catch {
        // ignore parse errors
      }
    }
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
}
